import { useLocation, useNavigate } from 'react-router-dom'
import { getParentPathname } from '../util/getParentPathname'

const useNavigatePrevPage = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const prevPathname = getParentPathname(pathname)

  const navigatePrevPage = () => {
    navigate(prevPathname, { replace: true })
  }

  return { navigatePrevPage }
}

export default useNavigatePrevPage
